import IllustExit from '@icons/IllustExit';
import { IllustGroup } from '@icons/IllustGroup';
import IllustInactive from '@icons/IllustInactive';
import { IllustNew } from '@icons/IllustNew';
import { IllustNomember } from '@icons/IllustNomember';
import { IllustOut } from '@icons/IllustOut';
import { IllustSchedule } from '@icons/IllustSchedule';
import { IllustSubscriptionUsage } from '@icons/IllustSubscriptionUsage';
import { IllustSubscriptionUse } from '@icons/IllustSubscriptionUse';
import { IllustSubscriptionUser } from '@icons/IllustSubscriptionUser';
import type { EventName } from '@repositories/workflowBaseTriggerRepository/workflowBaseTrigger.types';

interface TriggerIconProps {
  triggerName: EventName;
  width?: number;
  height?: number;
}

export const TriggerIcon = ({ triggerName, width = 40, height = 40 }: TriggerIconProps) => {
  switch (triggerName) {
    // 새로운 구성원이 추가되었을 때
    case 'TENANT_MEMBER_JOINED':
      return <IllustNew width={width} height={height} />;
    // 구성원이 탈퇴되었을 때
    case 'TENANT_MEMBER_LEFT':
      return <IllustExit width={width} height={height} />;
    // 구성원이 특정 그룹에 소속되었을 때
    case 'MEMBER_GROUP_JOINED':
      return <IllustGroup width={width} height={height} />;
    // 구성원이 속한 그룹이 변경되었을 때
    case 'MEMBER_GROUP_LEFT':
      return <IllustOut width={width} height={height} />;
    // 사전에 지정한 시간 간격으로 액션을 실행
    case 'SCHEDULED_EVENT_TRIGGERED':
      return <IllustSchedule width={width} height={height} />;
    // 마지막 사용일을 기준으로 비활성 사용자로 감지되었을 때
    case 'INACTIVE_USER_DETECTED':
      return <IllustInactive width={width} height={height} />;
    // 구성원으로 등록되지 않은 사용자가 감지되었을 때
    case 'EXTERNAL_USER_DETECTED':
      return <IllustNomember width={width} height={height} />;
    // 구독 사용자가 추가되었을 때
    case 'SUBSCRIPTION_USER_ADDED':
      return <IllustSubscriptionUser width={width} height={height} />;
    // 구성원이 제품 사용을 신청했을 때
    case 'SUBSCRIPTION_USE_REQUEST_ADDED':
      return <IllustSubscriptionUse width={width} height={height} />;
    // 제품 사용 신청에 대한 승인 절차 상태가 변경되었을 때
    case 'SUBSCRIPTION_USE_REQUEST_APPROVAL_STEP_STATUS_CHANGED':
      return <IllustSubscriptionUse width={width} height={height} />;
    // 제품 사용 신청에 대한 상태가 변경되었을 때
    case 'SUBSCRIPTION_USE_REQUEST_STATUS_CHANGED':
      return <IllustSubscriptionUse width={width} height={height} />;
    // 구독 핵심 사용량이 변경되었을 때
    case 'SUBSCRIPTION_USAGE_CHANGED':
      return <IllustSubscriptionUsage width={width} height={height} />;
    default:
      return null;
  }
};
